import { getLocale } from "../runtime";

const sv_outofstockmessage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vi skickar ett mejl så fort produkten är tillbaka i lager.`
};

const outofstockmessage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_outofstockmessage(inputs)
	return "outOfStockMessage";
};

export { outofstockmessage as "outOfStockMessage" };